import { 
    useState, 
    useEffect, 
    useReducer,
    useRef,
    useCallback,
    useContext,
    createContext,
    StrictMode
} from 'react';

import { 
    render,
    createPortal
} from 'react-dom';

import parse, { 
    attributesToProps,
    domToReact
} from 'html-react-parser';


import WpBlockCwcSlider from '../blocks/slider/src/view.jsx';
import WpBlockCwcSlides from '../blocks/slides/src/view.jsx';


export const ActionContext = createContext()
export const SettingsContext = createContext()


const domReplaceRules = {
    replace: ( { 
        type,
        attribs, 
        children
    } ) => {
        if ( type == 'tag' ) {
            let Component

            if ( attribs?.['data-display'] && attribs?.['data-display'] == 'skip' ) {
                return <>{ domToReact( children, domReplaceRules ) }</>
            }


            if ( attribs?.['data-component-name'] ) {
                const { 
                    ['data-component-name']: ComponentName,
                    ...props 
                } = attribs

                switch ( ComponentName ) {
                    case 'dots':
                        Component = Controls

                        break;
                }

                if ( Component ) {
                    return (
                        <Component 
                            { ...attributesToProps( props ) }
                        >
                            { domToReact( children, domReplaceRules ) }
                        </Component>
                    )
                }
            }


            if ( attribs?.['data-block-name'] ) {
                const { 
                    ['data-attributes']: attributes,
                    //['data-block-name']: blockName,
                    ...props 
                } = attribs
                let innerBlocks

                switch ( attribs['data-block-name'] ) {
                    case 'cwc/slider':
                        Component = WpBlockCwcSlider
                        innerBlocks = children

                        break;

                    case 'cwc/slides':
                        Component = WpBlockCwcSlides
                        innerBlocks = children.filter( el => el.type != 'text' )

                        break;

                    /*case 'cwc/slide':
                        Component = WpBlockCwcSlide
                        innerBlocks = children

                        break;*/
                }


                if ( Component ) {
                    return (
                        <Component 
                            { ...JSON.parse( attributes ) }
                            { ...attributesToProps( props ) }
                        >
                            { domToReact( innerBlocks, domReplaceRules ) }
                        </Component>
                    )
                }
            }
        }
    }
}


/**
 * Display thumbnails
 * @prop {boolean} autoplay - Autoplay flag
 * @prop {integer} currentIndex - Current clide index
 * @prop {function} setSlide - Set current slide
 * @prop {integer} rate - Transition rate
 */
export function Dots(props) {
    const { 
        currentIndex: [
            prex,
            current,
            next
        ],
        switchSlide
    } = useContext( ActionContext )

    
    return (
        <div 
            className="wp-block-cwc-slider__dots"
            onPointerEnter={ () => props.autoplay && props.stopOnHover ? props.setPlay( false ) : null } 
            onPointerLeave={ () => props.autoplay && props.stopOnHover ? props.setPlay( true ) : null }
        >
            { props.children.map( (slideNode, i) => {
                const {
                    media 
                } = JSON.parse( slideNode.dataset.attributes )


                return (
                    <div 
                        className={ `wp-block-cwc-slider__dot${current === i ? ' is-current' : ''}` } 
                        onClick={ () => switchSlide( i ) }
                    >
                        { media.url && 
                            <img src={ media?.thumbnail ?? media.url } />
                        }
                    </div>
                )
            } ) }
        </div>
    )
}



function initBlock(target) {
    const targetBlocks = target.querySelectorAll( '[data-block-name="cwc/slider"]' ) 

    if ( targetBlocks.length ) { 
        targetBlocks.forEach( targetBlock => {
            //if ( renderId ) {
                render( 
                    <StrictMode>
                        <WpBlockCwcSlider
                            { ...JSON.parse( targetBlock.dataset.attributes ) }
                            slidesCount={ parseInt( targetBlock.dataset.slideBlocksCount ) }
                            defaultIndex={ parseInt( targetBlock.dataset.defaultIndex ) }
                            hasMobile={ !!targetBlock.dataset.hasMobile }
                        >
                            { parse( targetBlock.innerHTML, domReplaceRules ) }
                        </WpBlockCwcSlider>
                    </StrictMode>, targetBlock 
                )
            //}
        } )
    }
}


document.addEventListener( 'DOMContentLoaded', ( { target } ) => {
    const formObserver = new MutationObserver( (mutationsList, observer) => {
        for ( const mutation of mutationsList ) {
            if ( mutation.type == 'childList' && mutation.addedNodes.length ) {
                for (const node of mutation.addedNodes) {
                    if ( node.nodeType == 1 ) {
                        // init block from update
                        initBlock( node )
                    }
                }
            }
        }
    } )

    formObserver.observe( target.body, {
        childList: true,
        subtree: true
    } )

    // init block from load
    initBlock( target.body )
} )